<template>
    <div>        
        <div v-for="(choice, index) in choiches" v-bind:key="uniqueName+'-'+index" style="position: relative;"> 
            <div class="card mb-1">
                <div class="card-body">
                    <form-element
                        v-for="(d, uniqueName) in subfields"
                        :key="uniqueName"
                        :error-color="aspect.errorColor"
                        :name="d.name"
                        :unique-name="uniqueName"
                        :label="d.label"
                        :type="d.type"
                        :options="d.options"
                        v-model="value[index][uniqueName]"
                        :placeholder="d.placeholder"
                        :editable="editable"
                        :tooltip="d.tooltip"
                        :oldValue="oldValue && oldValue[index] && oldValue[index][uniqueName]?oldValue[index][uniqueName]:null"
                        :required="d.required"
                        :visible.sync="d.visible"
                        :visibility-conditions="d.visibilityConditions"
                        :form-fields="formFields"
                        :submitted="submitted"
                        :validations="d.validations"
                        :translations="translations"
                        :aspect="aspect"
                        :location="location"
                        :err.sync="d.error"
                        :hidden="d.hidden"
                        :force-status-icon="forceStatusIcon"
                        :response.sync="d.response"
                        :refresh-index="d.refreshIndex"
                        :tooltip-position="tooltipPosition"
                        :show-icons-in-inputs="showIconsInInputs"
                        :subfields="d.subfields"
                        @change="handleChange"
                    ></form-element>
                </div>
            </div>
        </div>
        <div class="text-right" v-if="editable">
            <button type="button" @click="addRow"  class="btn btn-primary btn-sm" v-html="translations.addMultipleSelectLabel"></button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'form-element-repeater',
    props: {
        name: {type: String, required: true},
		uniqueName: {type: String, required: true},
        value:{type:Array},
        errorColor: {type: String, default: 'red'},
        type: {type: String, default: 'text'},
        label: null,
        oldValue: null,
        options:  {type: Object, default: function(){ return {}; }},
        placeholder: null,
        submitted: null,
        editable: {type: Boolean, default: true},
        tooltip: {type: String, default: ''},
        required: {type: Boolean, default: false},
        formFields: {type: Object, default: function(){ return {}; }},
        hidden: {type: Boolean, default: false },
        visibilityConditions: {type: Array, default: function(){ return []; }},
        validations: {type: Array, default: function(){ return []; }},
        translations: {type: Object, default: function(){ return {}; }},
        aspect: {type: Object, default: function(){ return {}; }},
        location: {type: Object, default: function(){ return {}; }},
        err: {type: Boolean, default: true},
        forceStatusIcon: {type: Boolean, default: false},
        response: null,
        refreshIndex: {type: Number, default: 0},
        tooltipPosition: { type:String, default: "bottom" },
        showIconsInInputs: { type:Boolean, default: true },
        subfields: {type: Object, default: function(){ return {}; }}
    },
    data(){
        return {
            choiches: [],
        }
    },
    mounted(){
        if(this.value && this.value.length > 0){
            for(var i=0; i<this.value.length; i++){
                this.addRow();
            }
        }
    },
    methods: {
        handleChange(uniqueName){
            this.$emit("change", uniqueName);
        },
        removeRow(index){
            this.choiches.splice(index,1);
        },
        addRow(){
            var val = [];
            if(this.value != undefined && this.value != null){
                val = this.value.slice(0);
            }
            val.push({});
            this.$emit("input", val);
            this.choiches.push(null);
            return false;
        },
    }
}
</script>